import React, { useEffect } from "react";
import "./App.css";
import Router from "components/Router";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "components/Spinner";
import { setCountry } from 'redux/actions/countrySelection';
import Select from 'react-select';
import GlobeIcon from "assets/svg/GlobeIcon";
import { customSelectStylesForLocale } from 'helpers';
import { allowedLocales } from "redux/reducers/countrySelection";

const App = () => {
  const dispatch = useDispatch();
  const loaderVisible = useSelector((state) => state.loader.loaderVisible);
  const { selectedCountry, countriesList } = useSelector((state) => state.countrySelection);

  useEffect(() => {
    const loggedInUserInfo = JSON.parse(localStorage.getItem("loggedInUserData"));
    if (loggedInUserInfo?.country?.toUpperCase() === "USA") {
      dispatch(setCountry({
        ...allowedLocales[0],
        userCountry: "USA",
        showSelector: false,
      }));
    }
  }, [dispatch]);

  return (
    <div className="App">
      {loaderVisible && <Spinner />}
      {selectedCountry?.showSelector && (
        <div className="country-language-styles" >
          {/* <GlobeIcon /> */}
          <Select
            id="country"
            name='Country'
            value={countriesList?.find((cntry) => cntry?.value === selectedCountry?.value)}
            options={countriesList}
            styles={customSelectStylesForLocale}
            onChange={(data) => {
              const dispatchValue = countriesList?.find((cntry) => cntry?.value === data?.value)
              dispatch(setCountry({ ...dispatchValue, userCountry: "CANADA", showSelector: true }))
            }}
          />
        </div>
      )}
      <Router />
    </div>
  );
};

export default App;
